<img [fill]="true"
     [dfImage]="mainImage() || ''"
     [alt]="altText() || ''">

@if (canPrintAltImage()) {
<img class="alt-image"
     [fill]="true"
     [dfImage]="altImage() || ''"
     [alt]="altText() || ''">
}